import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Container, Header, Footnote, Anchor } from 'Components/core';
import { colors } from 'Constants';

 

// Images
 

// State
import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { toArray } from 'Root/libs/array';
import { SubHeader, TitleHeader } from 'Components/core/Header';
 
 
function hexToRgb(hex, alpha) {

  return '#ffffff'
  // 

  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? `rgba(
      ${parseInt(result[1], 16)},
      ${parseInt(result[2], 16)},
      ${parseInt(result[3], 16)},
      ${alpha || 1})`
    : undefined;
}

const Table = styled.table`
margin-top:20px ;
 
  tr > * {
    padding: 8px;
    ${props => props.center && css(`text-align: center;`)}
  }

  th {
    font-weight: normal;
    text-align: left;
  }

  tr:nth-child(1) {
    th:nth-child(1) {
      background-color: ${props => props.color1};
      color: ${colors.textOnAccent};
      
    }

    th:nth-child(3n + 2) {
      background-color: ${props => props.color2};
      color: ${colors.textOnAccent};
    }

    th:nth-child(3n + 3) {
      background-color: ${props => props.color3};
      color: ${colors.textOnAccent};
    }
    th:nth-child(3n + 4) {
      background-color: ${props => props.color4};
      color: ${colors.textOnAccent};
    }
  }

 

  
`;

export default () => {

  useEffect(()=>{
    Api.recordAcitity(CODES.Coverage_Rates );
  },[]);


 

  return  (
    <Subscribe to={[ApiStore]}>
      {state => {
 

        return (
          <Container
            seperation="32px"
            column
            maxWidth
            style={{ margin: 'auto', padding: '32px' }}
          >
            <TitleHeader>Coverage <SubHeader>periods and rates</SubHeader> </TitleHeader>
            
           
            {state?.asaCoverage?.chart && <div>
              {toArray(state?.asaCoverage?.chart).map(chart=><div style={{marginBottom:80}}>
                <div>{chart.title}</div>
                <div>{chart.summary}</div>
                <div>
                  <Table                        color1="#081f65"
                    color2={'#081f65'} 
                    color3="#081f65"
                    color4="#081f65">
                    <tbody>
                      {chart.table.tr.map(row=><tr>
                        {row.th && row.th.map(td=><th>{td}</th>)}
                        {row.td && row.td.map(td=><td>{td}</td>)}
                         
                      </tr>)}
                    </tbody>
                  </Table>
                  {chart.footNote && <Footnote>{chart.footNote}</Footnote>}
                  {chart.footNotes && <Footnote>{chart.footNotes.footNote.map(text=><div>{text}</div>)}</Footnote>}
                </div>
              </div>)}

              {state.asaCoverage.footNotes && <div>{toArray(state.asaCoverage.footNotes.footNote).map(text=><Footnote>{text}</Footnote>)}</div> }
            </div>}

          </Container>
        );
      }}
    </Subscribe>
  );
};